import { defineStore } from 'pinia';
import axios from 'axios';
import { remove } from 'lodash-es';

export type NotificationItemType = {
	id: string;
	title: string;
	type: string;
	data: Record<string, any>;
	created_at: string;
};

export const useAppNotificationStore = defineStore({
	id: 'appNotifications',
	state: () => {
		return {
			enabled: false,
			notifications: Array<NotificationItemType>(),
		};
	},
	actions: {
		enable() {
			this.$state.enabled = true;
		},
		/*push(notifications: Array<NotificationItemType>) {
            this.$state.notifications.push(...notifications);
        },*/
		/*remove(notification: NotificationItemType) {
            remove(this.$state.notifications, (n) => n.id === notification.id);
        },*/
		markAsRead(notification: NotificationItemType) {
			remove(this.$state.notifications, (n) => n.id === notification.id);
			axios.put(`notifications/${notification.id}`, { read_at: new Date().toISOString() });
		},
		sync() {
			if (this.$state.enabled) {
				axios.get('notifications').then((response) => {
					this.$state.notifications = response.data;
				});
			}
		},
	},
});
